import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthService } from '../../../services';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  email;

  constructor(
    public snackBar: MatSnackBar,
    private router: Router,
    private authService: AuthService) { }

  ngOnInit() {
  }

  submit() {
    const s = this.authService.tryRecoverPassword(this.email).subscribe((data: any) => {
      this.snackBar.open(`Access restore link was sent to ${this.email}`, null, {
        duration: 5000,
        panelClass: ['app-mat-snack-bar']
      });
      this.router.navigate(['']);
    });
  }

  onKeyDown(e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      this.submit();
    }
  }
}
